import { MutationTree } from 'vuex';
import { PrepaidSimState, Item, Payload } from '@/store/prepaidSim/state';

const buildItem = (payload: Payload, count: number): Item => {
  return { id: payload.id, count: count };
};

const findIndex = (list: Item[], payload: Payload) => {
  return list.findIndex(v => {
    return v && v.id && v.id === payload.id;
  });
};

const mutations: MutationTree<PrepaidSimState> = {
  update: (state, payload: Payload) => {
    const index = findIndex(state.prepaidSim, payload);
    state.prepaidSim.splice(
      index,
      1,
      buildItem(payload, payload.count as number)
    );
  },
};

export default mutations;
